import type { ConsentCategories } from './types'

type GtagConsentState = 'granted' | 'denied'

type GtagConsentPayload = {
  ad_storage: GtagConsentState
  ad_user_data: GtagConsentState
  ad_personalization: GtagConsentState
  analytics_storage: GtagConsentState
  personalization_storage: GtagConsentState
  functionality_storage: GtagConsentState
  security_storage: GtagConsentState
}

function toPayload(categories: ConsentCategories): GtagConsentPayload {
  const marketing: GtagConsentState = categories.marketing ? 'granted' : 'denied'
  const analytics: GtagConsentState = categories.analytics ? 'granted' : 'denied'
  const personalization: GtagConsentState = categories.personalization ? 'granted' : 'denied'
  return {
    ad_storage: marketing,
    ad_user_data: marketing,
    ad_personalization: marketing,
    analytics_storage: analytics,
    personalization_storage: personalization,
    functionality_storage: 'granted',
    security_storage: 'granted',
  }
}

export function setDefaultGtagConsent() {
  if (typeof window === 'undefined') return
  const gtag = window.gtag
  if (typeof gtag !== 'function') return
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    personalization_storage: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
  })
}

export function updateGtagConsent(categories: ConsentCategories) {
  if (typeof window === 'undefined') return
  const gtag = window.gtag
  if (typeof gtag !== 'function') return
  gtag('consent', 'update', toPayload(categories))
}
